import Axios from "@/api/baseApi";

export default {
  addOrUpdate(items) {
    return Axios.post(`/api-registration/v1/piglet-transports`, items);
  },
  createDeliveryNotes(form) {
    return Axios.post(`/api-registration/v1/delivery-note/from-transport`, form);
  },
  fetchByWeekId(weekId) {
    return Axios.get(`/api-registration/v1/piglet-transports/week/${weekId}`);
  },
  fetchInstructions(tranporterId, transportDate, transporterIndex, driver) {
    return Axios.get(`/api-registration/piglet-transport-instructions/v1?transporterId=${tranporterId}&transportDate=${transportDate}&transporterIndex=${transporterIndex}&driver=${driver}`);
  },
  move(pigletTransportId, calendarWeekId) {
    return Axios.post(`/api-registration/v1/piglet-transports/move/${pigletTransportId}`, {calendarWeekId});
  },
  split(pigletTransportId) {
    return Axios.post(`/api-registration/v1/piglet-transports/split/${pigletTransportId}`);
  },
  remove(pigletTransportId) {
    return Axios.delete(`/api-registration/v1/piglet-transports/${pigletTransportId}`);
  }
}

